import user from './components/user_store'
import app from './components/app_store'

export default {
    user,
    app,
    // TODO more
}